/**
 * Central app configuration: routes, storage keys, pagination, feature flags, roles.
 * All routes and feature flags derive from here; role-based checks use ROLES.
 */

export const APP_NAME = 'Infinity Sport ERP';

// Route path constants (no magic strings in route definitions)
export const ROUTES = {
  HOME: '/',
  LOGIN: '/login',
  FORGOT_PASSWORD: '/forgot-password',
  RESET_PASSWORD: '/reset-password',
  DASHBOARD: '/dashboard',
  ORDERS: '/orders',
  LOCAL_ORDERS: '/local-orders',
  PURCHASE_ORDERS: '/purchase-orders',
  CLIENTS: '/clients',
  PRODUCTS: '/products',
  USERS: '/users',
  SECTIONS: '/sections',
  ARTICLE: '/article',
  STOCK: '/stock',
  NOT_FOUND: '/404',
};

// Storage keys
export const STORAGE_KEYS = {
  AUTH: process.env.REACT_APP_AUTH_STORAGE_KEY || 'infinity_erp_auth',
  LANGUAGE: 'infinity_erp_lang',
};

// Pagination defaults for list pages
export const PAGINATION = {
  DEFAULT_PAGE_SIZE: 10,
  PAGE_SIZE_OPTIONS: [10, 25, 50, 100],
};

// Supported roles (for ProtectedRoute allowedRoles)
// Note: In this app, seller = manager (shop_manager)
export const ROLES = {
  ADMIN: 'administrator',
  SUPER_ADMIN: 'super_administrator',
  MANAGER: 'shop_manager', // This is the seller role
  SELLER: 'shop_manager', // Alias for manager/seller
  CUSTOMER: 'customer',
};

// Feature flags (can be overridden by REACT_APP_FEATURE_FLAGS env)
const envFlags = process.env.REACT_APP_FEATURE_FLAGS
  ? process.env.REACT_APP_FEATURE_FLAGS.split(',').map((f) => f.trim())
  : [];

export const FEATURE_FLAGS = {
  PWA_INSTALL: envFlags.length === 0 || envFlags.includes('PWA_INSTALL'),
  DASHBOARD_CHARTS: envFlags.length === 0 || envFlags.includes('DASHBOARD_CHARTS'),
  ...Object.fromEntries(envFlags.filter(Boolean).map((f) => [f, true])),
};

// Route metadata for nav and access (path, label i18n key, roles, feature flag)
export const ROUTE_CONFIG = [
  { path: ROUTES.HOME, label: 'nav.home', public: true },
  { path: ROUTES.LOGIN, label: 'nav.login', public: true },
  { path: ROUTES.DASHBOARD, label: 'nav.dashboard', roles: [ROLES.ADMIN, ROLES.SUPER_ADMIN], flag: 'DASHBOARD_CHARTS' },
    { path: ROUTES.STOCK, label: 'nav.stock', roles: [ROLES.ADMIN, ROLES.SUPER_ADMIN, ROLES.MANAGER] }, // MANAGER = seller
    { path: ROUTES.ORDERS, label: 'nav.orders', roles: [ROLES.ADMIN, ROLES.SUPER_ADMIN, ROLES.MANAGER] },
    { path: ROUTES.LOCAL_ORDERS, label: 'nav.localOrders', roles: [ROLES.ADMIN, ROLES.SUPER_ADMIN, ROLES.MANAGER] },
    { path: ROUTES.PURCHASE_ORDERS, label: 'nav.purchaseOrders', roles: [ROLES.ADMIN, ROLES.SUPER_ADMIN] },
    { path: ROUTES.CLIENTS, label: 'nav.clients', roles: [ROLES.ADMIN, ROLES.SUPER_ADMIN, ROLES.MANAGER] },
    { path: ROUTES.PRODUCTS, label: 'nav.products', roles: [ROLES.ADMIN, ROLES.SUPER_ADMIN, ROLES.MANAGER] },
    // { path: ROUTES.SECTIONS, label: 'nav.sections', roles: [ROLES.ADMIN, ROLES.SUPER_ADMIN] },
  // { path: ROUTES.ARTICLE, label: 'nav.article', roles: [ROLES.ADMIN, ROLES.SUPER_ADMIN, ROLES.MANAGER] },
  { path: ROUTES.USERS, label: 'nav.users', roles: [ROLES.ADMIN, ROLES.SUPER_ADMIN] },
];

export default {
  APP_NAME,
  ROUTES,
  STORAGE_KEYS,
  PAGINATION,
  ROLES,
  FEATURE_FLAGS,
  ROUTE_CONFIG,
};
